import React from 'react';

import useAuth from 'src/hooks/useAuth';

// Corresponds to the "HydroForecast Beacon" in Help Scout.
const DASHBOARD_BEACON_ID = '3756b21c-20f1-48a6-90d3-028c1d6a9613';

// The class name that we use to toggle the HelpScout Beacon visibility by
// adding and removing from the document's <body> element.
export const HIDE_HELPSCOUT_BEACON_CLASS_ID = 'hide-helpscout-beacon';

const HelpScout: React.FunctionComponent<{}> = () => {
  const auth = useAuth();

  // We split this out so we only run 'init' when the profile object changes.
  // Insulates us from re-initializing on other auth object changes.
  const profile = auth.status === 'logged in' ? auth.userProfile : null;

  React.useEffect(() => {
    (window as any)?.Beacon?.('init', DASHBOARD_BEACON_ID);

    if (profile) {
      (window as any)?.Beacon?.('identify', {
        name: profile.name,
        email: profile.email,
      });
    }

    return () => {
      (window as any)?.Beacon?.('logout');
      (window as any)?.Beacon?.('destroy');
    };
  }, [profile]);

  return null;
};

export const HideHelpScoutBeacon: React.FunctionComponent<{}> = () => {
  React.useEffect(() => {
    const {classList} = document.body;

    hideBeacon(classList);

    return () => showBeacon(classList);
  }, []);

  return null;
};

export function openHelpScoutBeacon() {
  const {classList} = document.body;

  // If the Beacon is hidden temporarily show the HelpScout Beacon, but hide it
  // again when the Beacon is closed.
  if (getIsHidden(classList)) {
    showBeacon(classList);
    (window as any)?.Beacon?.('once', 'close', () => hideBeacon(classList));
  }

  (window as any)?.Beacon?.('open');
}

function getIsHidden(classList: DOMTokenList) {
  return classList.contains(HIDE_HELPSCOUT_BEACON_CLASS_ID);
}

function hideBeacon(classList: DOMTokenList) {
  if (!getIsHidden(classList)) {
    classList.add(HIDE_HELPSCOUT_BEACON_CLASS_ID);
  }
}

function showBeacon(classList: DOMTokenList) {
  if (getIsHidden(classList)) {
    classList.remove(HIDE_HELPSCOUT_BEACON_CLASS_ID);
  }
}

export default HelpScout;
